import './ConfirmModal.css';

export const ConfirmModal = ({ show, onClose, onConfirm, title, text, confirmButtonColor = 'red', isLoading = false }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="confirm-modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
        </div>
        <div className="modal-body">
          <p>{text}</p>
        </div>
        <div className="modal-buttons">
          <button 
            className="button button-grey" 
            onClick={onClose}
            disabled={isLoading}
          >
            No
          </button>
          <button 
            className={`button button-${confirmButtonColor} ${isLoading ? 'button-loading' : ''}`} 
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="dots-loading">
                <span></span>
                <span></span>
                <span></span>
              </span>
            ) : (
              'Si'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};